export default __webpack_public_path__ + "static/media/shareTip.ac557b53.png";